// Hero controller (canonical name: `landing--hero`)
// Enhances the server-rendered hero partial in-place.

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    title: String,
    subtitle: String,
  }

  declare readonly titleValue: string
  declare readonly subtitleValue: string

  connect() {
    // Lightweight enhancement: mark connected and apply any non-empty values.
    try {
      this.element.setAttribute('data-landing-hero-connected', 'true')

      if (typeof this.titleValue !== 'undefined') {
        const titleEl = this.element.querySelector('.hero-title, .text-6xl, .text-5xl, .text-4xl, h1, h2') as HTMLElement | null
        if (titleEl && (this.titleValue || '').toString().trim().length > 0) titleEl.textContent = this.titleValue
      }

      if (typeof this.subtitleValue !== 'undefined') {
        const subtitleEl = this.element.querySelector('.hero-subtitle, .text-base, p') as HTMLElement | null
        if (subtitleEl && (this.subtitleValue || '').toString().trim().length > 0) subtitleEl.textContent = this.subtitleValue
      }

      const ctaElements = Array.from(this.element.querySelectorAll('a, button')) as HTMLElement[]
      ctaElements.forEach((el, idx) => {
        const existing = el.getAttribute('data-controller') || ''
        const parts = existing.split(/\s+/).filter(Boolean)
        if (!parts.includes('button')) {
          parts.push('button')
          el.setAttribute('data-controller', parts.join(' '))
        }
        if (idx === 0) el.dataset.heroCta = 'primary'
      })
    } catch (err) {
      // initialization failed; swallow to avoid breaking page JS
    }
  }

  disconnect() {
    // No observers installed in this lightweight controller.
  }
}
